const _CHARTCOLORS = {
    PRIMARY: '#283593',
    PRIMARYDARK: '#001064',
    PRIMARYLIGHT: '#5f5fc4',
    SECONDARY: '#ff6f00',
    SECONDARYDARK: '#c43e00',
    SECONDARYLIGHT: '#ffa040',
}

exports.CHARTCOLORS = _CHARTCOLORS